import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';

export class ServiceChargeDto extends BaseDto {
    merchantGroupId: number;
    name: string;
    serviceChargeModeId: number;
    percent: number;
    enabled: boolean;
    sequence: number;
    merchants: MerchantDto[];
    hasManagerAuthorisation: boolean;
    enabledForThisMerchant: boolean;
}